module.exports = __webpack_public_path__ + "static/media/Huobi.19437406.png";